if (!customElements.get('ow-prescription-entry')) {
  customElements.define(
    'ow-prescription-entry',
    class OwPrescriptionEntry extends HTMLElement {
      constructor() {
        super();
        this.prescription = this.querySelectorAll('[id^="prescription-"]');
        this.prescription.forEach((prescription) => {
          prescription.addEventListener('change', this.onChangeHandler.bind(this));
        });
        this.errorMessages = document.querySelector('#error-messages-prescription');
      }
      connectedCallback() {
        this.handleChange(this.querySelector('[id="prescription-os-box"]'));
        this.handleChange(this.querySelector('[id="prescription-od-box"]'));
      }

      onChangeHandler(evt) {
        this.handleChange(evt.target);
      }

      handleChange(element) {
        if (
          (element.id === 'prescription-od-box' || element.id === 'prescription-os-box') &&
          (element.value === '0' || element.value === '0')
        ) {
          this.deactivateSelectedElements(element);
        } else if (element.id === 'prescription-od-box' || element.id === 'prescription-os-box') {
          this.activateSelectedElements(element);
        }
      }

      deactivateSelectedElements(currentElement) {
        let boxes_total_count = 0;
        for (const element of this.prescription) {
          switch (element.id) {
            case 'prescription-od-box':
            case 'prescription-os-box':
              boxes_total_count += parseInt(element.value);
              break;
            default:
              if (
                element.id.substring(0, 15) === currentElement.id.substring(0, 15) &&
                element.dataset.optionsCount > 1
              ) {
                element.value = '';
                element.classList.add('!ow-bg-grey-200');
                element.removeAttribute('required');
                element.classList.remove('required');
                element.parentNode.classList.add('ow-pointer-events-none');
              }
          }
        }
        if (boxes_total_count === 0) {
          this.handleErrorMessage(this.errorMessages.dataset.errorBoxQuantity);
        } else {
          document.querySelector('[name="quantity"]').value = boxes_total_count;
        }
      }

      activateSelectedElements(currentElement) {
        let boxes_total_count = 0;
        this.handleErrorMessage();
        for (const element of this.prescription) {
          switch (element.id) {
            case 'prescription-od-box':
            case 'prescription-os-box':
              boxes_total_count += parseInt(element.value);
              break;
            default:
              if (
                element.id.substring(0, 15) === currentElement.id.substring(0, 15) &&
                element.dataset.optionsCount > 1
              ) {
                element.value = '';
                element.setAttribute('required', true);
                element.classList.add('required');
                element.classList.remove('!ow-bg-grey-200');
                element.parentNode.classList.remove('ow-pointer-events-none');
              }
          }
        }
        if (boxes_total_count > 0) {
          document.querySelector('[name="quantity"]').value = boxes_total_count;
        }
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(`#product-box-error-message`);
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(`#product-box-error-message .product-form__error-message`);

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
        document.querySelector('.product-form__submit').toggleAttribute('disabled', errorMessage);
      }
    }
  );
}
